/*
 * ------------ Theme Common JS ------------
 */

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter((el) => {
    if (el.closest("[inert]")) return false;
    if (el.getAttribute("aria-hidden") === "true") return false;
    if (el.getClientRects().length > 0) return true;
    const position = getComputedStyle(el).position;
    return position === "fixed" || position === "sticky";
  });
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;

    const elements = getFocusableElements(container);
    if (elements.length === 0) return;

    const first = elements[0];
    const last = elements[elements.length - 1];
    const target = event.target;

    if (!container.contains(target)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }

    // Shadow-DOM hosts (payment terms, dynamic checkout) retarget events to the
    // host, which is absent from the list — hijack Tab only at real boundaries
    // and let the browser walk everything in between; focusin covers escapes.
    if (event.shiftKey) {
      if (target === first || target === container) {
        event.preventDefault();
        last.focus();
      }
    } else if (target === last || target === container) {
      event.preventDefault();
      first.focus();
    }
  };

  trapFocusHandlers.focusin = (event) => {
    if (container.contains(event.target)) return;

    const elements = getFocusableElements(container);
    elements[0]?.focus();
  };

  document.addEventListener("keydown", trapFocusHandlers.keydown, true);
  document.addEventListener("focusin", trapFocusHandlers.focusin, true);

  elementToFocus?.focus({ preventScroll: true });
}

function pauseAllMedia(parentElement = document, exceptElement = null) {
  parentElement.querySelectorAll(".js-youtube").forEach((video) => {
    if (exceptElement && exceptElement.contains(video)) return;
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  parentElement.querySelectorAll(".js-vimeo").forEach((video) => {
    if (exceptElement && exceptElement.contains(video)) return;
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  parentElement.querySelectorAll("video").forEach((video) => {
    if (exceptElement && exceptElement.contains(video)) return;
    video.pause();
  });
  parentElement.querySelectorAll("product-model").forEach((model) => {
    if (exceptElement && exceptElement.contains(model)) return;
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin, true);
  document.removeEventListener("focusout", trapFocusHandlers.focusout, true);
  document.removeEventListener("keydown", trapFocusHandlers.keydown, true);

  if (
    elementToFocus &&
    !elementToFocus.classList.contains("product-card__quickview-button")
  ) {
    elementToFocus.focus();
  }
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  cents = parseInt(cents, 10);

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}

function slideUp(toggleEl, contentEl, duration = 300) {
  // Get the current height of the element
  const height = contentEl.clientHeight;

  // Set animation styles
  contentEl.style.transitionProperty = "height, margin, padding";
  contentEl.style.transitionDuration = duration + "ms";
  contentEl.style.overflow = "hidden";

  // Set initial values
  contentEl.style.height = height + "px";
  contentEl.style.padding = "0";
  contentEl.style.margin = "0";

  // Delay to start animation
  setTimeout(function () {
    // Set the values ​​for hiding the element
    contentEl.style.height = "0";
    contentEl.style.padding = "0";
    contentEl.style.margin = "0";
  }, 10);

  // Delay for animation to complete
  setTimeout(function () {
    // Remove installed styles after animation
    toggleEl.classList.remove("active");
    contentEl.classList.remove("active");
    contentEl.style.removeProperty("height");
    contentEl.style.removeProperty("padding");
    contentEl.style.removeProperty("margin");
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("transition-duration");
    contentEl.style.removeProperty("transition-property");
  }, duration);
}

function slideDown(toggleEl, contentEl, duration = 300) {
  toggleEl.classList.add("active");
  contentEl.classList.add("active");
  contentEl.style.overflow = "hidden";
  contentEl.style.height = "0";

  const height = contentEl.scrollHeight;

  setTimeout(function () {
    contentEl.style.height = height + "px";
  }, 10);

  setTimeout(function () {
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("height");
  }, duration);
}

function setHasScrollClass(el) {
  if (!el) return;
  el.classList.toggle("has-inner-scroll", el.scrollHeight > el.clientHeight);
}

if (!Element.prototype.replaceChildren) {
  Element.prototype.replaceChildren = function (...nodes) {
    while (this.firstChild) this.removeChild(this.firstChild);
    this.append(...nodes);
  };
}

/*
 * ------------ Shopify Common JS ------------
 */

if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    if (!opt) return;
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/*
 * ------------ Theme Custom Events ------------
 */

// [Theme custom event] - Cart UI refresh event
// External scripts dispatch `cart:refresh` on document to trigger a full
// re-render of cart count bubble, cart drawer, and cart page items.
document.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    {
      // The rendered section holds only the bubble snippet — the
      // #cart-count-bubble wrapper lives in the header markup, so the
      // source is looked up by the section wrapper instead.
      id: "cart-count-bubble",
      selector: "#cart-count-bubble",
      sourceSelector: ".shopify-section",
    },
    {
      id: "cart-drawer",
      selector: "#CartDrawer",
    },
    {
      id: "main-cart",
      selector: ".main-cart",
    },
  ];

  const sectionIds = sectionsToUpdate.map((s) => s.id).join(",");

  fetch(`${routes.cart_url}?sections=${sectionIds}`)
    .then((response) => response.json())
    .then((sections) => {
      sectionsToUpdate.forEach((section) => {
        const sectionHTML = sections[section.id];
        if (!sectionHTML) return;

        const html = new DOMParser().parseFromString(sectionHTML, "text/html");
        const sourceElement = html.querySelector(
          section.sourceSelector || section.selector
        );
        const destinationElements = document.querySelectorAll(section.selector);

        if (sourceElement && destinationElements.length > 0) {
          destinationElements.forEach((el) => {
            el.innerHTML = sourceElement.innerHTML;
            if (sourceElement.classList.contains("is-empty")) {
              el.classList.add("is-empty");
            } else {
              el.classList.remove("is-empty");
            }
          });
        }
      });
    })
    .catch((error) => {
      console.error("cart:refresh error:", error);
    });
});

/*
 * ------------ Theme Web Components ------------
 */

class ProductCard extends HTMLElement {
  connectedCallback() {}
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}

class ProductCardPlaceholder extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {}
}

if (!customElements.get("product-card-placeholder")) {
  customElements.define("product-card-placeholder", ProductCardPlaceholder);
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    // Zero quantity means "remove" in the cart and quick order list contexts
    this.allowZero = Boolean(
      this.closest(".cart-item") || this.closest(".quick-variant-item")
    );

    this.querySelectorAll("button").forEach((button) => {
      this.setMinimumDisable();

      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    var eventList = ["paste", "input"];

    for (const event of eventList) {
      this.input.addEventListener(event, (e) => {
        const value = e.currentTarget.value;
        const numberRegex = this.allowZero ? /^\d*$/ : /^0*?[1-9]\d*$/;

        if (numberRegex.test(value) || value === "") {
        } else {
          e.currentTarget.value = 1;
        }

        this.setMinimumDisable();
      });
    }

    this.input.addEventListener("focusout", (e) => {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
        this.setMinimumDisable();
      }
    });
  }

  setMinimumDisable() {
    if (!this.input) return;
    const value = Number(this.input.value);

    const minusBtn = this.querySelector('button[name="minus"]');
    if (minusBtn) {
      const minValue = this.input.min === "" ? 1 : Number(this.input.min);
      minusBtn.classList.toggle("disabled", value <= minValue);
    }

    const plusBtn = this.querySelector('button[name="plus"]');
    if (plusBtn) {
      const hasMax = this.input.max !== "";
      plusBtn.classList.toggle(
        "disabled",
        hasMax && value >= Number(this.input.max)
      );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    this.setMinimumDisable();
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(
      '[id^="ModalCloseBtn-"], [id^="ModalCloseOverlay-"]'
    ).forEach((el) => el.addEventListener("click", () => this.hide(false)));

    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        ) {
          this.hide();
        }
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;

    // Theme editor re-renders leave the previously moved copy in <body>;
    // the opener would keep finding that stale duplicate id, so replace it.
    const stale = this.id
      ? [...document.body.children].find(
          (el) => el.id === this.id && el !== this
        )
      : null;

    document.body.appendChild(this);

    if (stale) {
      const wasOpen = stale.hasAttribute("open");
      // hide() first so body scroll-lock/focus-trap don't leak if the
      // replacement can't reopen (e.g. quick-view without an opener)
      if (wasOpen) stale.hide();
      stale.remove();
      if (wasOpen) this.show(stale.openedBy);
    }
  }

  get closeCursor() {
    return this.querySelector("modal-close-cursor");
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.classList.add("modal--open");

    window.pauseAllMedia(this);

    this.addEventListener(
      "transitionend",
      () => {
        trapFocus(this, this.querySelector('[role="dialog"]'));
      },
      { once: true }
    );
    this.closeCursor?.activate();
  }

  hide() {
    this.removeAttribute("open");
    this.classList.remove("modal--open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia(this);
    document.body.classList.remove("overflow-hidden");
    this.closeCursor?.deactivate();
  }
}

if (!customElements.get("modal-dialog")) {
  customElements.define("modal-dialog", ModalDialog);
}

class ProductModal extends ModalDialog {
  constructor() {
    super();
  }
}

if (!customElements.get("product-modal")) {
  customElements.define("product-modal", ProductModal);
}

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    if (!button) return;

    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

if (!customElements.get("modal-opener")) {
  customElements.define("modal-opener", ModalOpener);
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (poster) {
      poster.addEventListener("click", this.loadContent.bind(this));
    }

    if (this.dataset.autoplay === "true") {
      this.loadContent();
    }
  }

  loadContent() {
    const parentEl =
      this.closest(".product__media") || this.closest(".product-media-modal");
    pauseAllMedia(parentEl);

    if (this.getAttribute("loaded")) return;

    const template = this.querySelector("template");
    if (!template) return;

    const content = document.createElement("div");
    content.appendChild(template.content.firstElementChild.cloneNode(true));
    this.setAttribute("loaded", true);

    const media = content.querySelector("video, model-viewer, iframe");
    if (!media) return;

    if (media && media.nodeName === "VIDEO") {
      media.setAttribute("controls", "true");
      media.play();
    }
    const deferredElement = this.appendChild(media);

    if (["VIDEO", "IFRAME"].includes(deferredElement.nodeName)) {
      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            let shouldAutoplay = false;
            const parentSlide = entry.target.closest(".swiper-slide");
            if (parentSlide) {
              if (parentSlide.classList.contains("swiper-slide-active")) {
                shouldAutoplay = true;
              }
            } else {
              if (entry.intersectionRatio > 0.7) {
                shouldAutoplay = true;
              }
            }

            if (shouldAutoplay) {
              if (
                (this.dataset.autoplay === "true" &&
                  !this.closest("product-modal")) ||
                (this.dataset.autoplay === "true" &&
                  this.closest("product-modal")?.hasAttribute("open"))
              ) {
                pauseAllMedia(parentEl, this);

                if (entry.target.nodeName === "VIDEO") {
                  entry.target.play()?.catch((error) => {
                    console.error("Error playing video:", error);
                  });
                } else if (
                  entry.target.nodeName === "IFRAME" &&
                  entry.target.contentWindow
                ) {
                  if (entry.target.classList.contains("js-youtube")) {
                    entry.target.contentWindow.postMessage(
                      '{"event":"command","func":"playVideo","args":""}',
                      "*"
                    );
                  } else {
                    entry.target.contentWindow.postMessage(
                      '{"method":"play"}',
                      "*"
                    );
                  }
                }
              }
            } else {
              if (entry.target.nodeName === "VIDEO") {
                entry.target.pause();
              } else if (
                entry.target.nodeName === "IFRAME" &&
                entry.target.contentWindow
              ) {
                if (entry.target.classList.contains("js-youtube")) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"pauseVideo","args":""}',
                    "*"
                  );
                } else {
                  entry.target.contentWindow.postMessage(
                    '{"method":"pause"}',
                    "*"
                  );
                }
              }
            }
          });
        },
        {
          threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
        }
      );

      videoObserver.observe(deferredElement);
    }

    const modelViewer = this.closest(".swiper-slide-active")?.querySelector(
      "model-viewer"
    );
    if (
      modelViewer &&
      !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
    ) {
      const swiper = this.closest(".swiper")?.swiper;
      if (swiper) {
        swiper.params.noSwiping = true;
        swiper.params.noSwipingClass = "swiper-slide";
      }
    }

    this.querySelectorAll(
      "video, .shopify-model-viewer-ui__controls-overlay"
    ).forEach((media) => {
      if (this.getAttribute("loaded") === "true") {
        media.addEventListener("click", (event) => {
          pauseAllMedia(parentEl, this);
        });
      }
    });
  }
}

if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}

class ProductModel extends DeferredMedia {
  constructor() {
    super();
  }

  loadContent() {
    super.loadContent();

    Shopify.loadFeatures([
      {
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this),
      },
    ]);
  }

  setupModelViewerUI(errors) {
    if (errors) return;

    this.modelViewerUI = new Shopify.ModelViewerUI(
      this.querySelector("model-viewer")
    );

    const $this = this;
    const target = $this.querySelector("model-viewer");

    const observer = new MutationObserver((records) => {
      if ($this.closest(".swiper") && $this.closest(".swiper").swiper) {
        const swiperObj = $this.closest(".swiper").swiper;
        if (!target.classList.contains("shopify-model-viewer-ui__disabled")) {
          swiperObj.params.noSwiping = true;
          swiperObj.params.noSwipingClass = "swiper-slide";
        } else {
          swiperObj.params.noSwiping = false;
        }
      }
    });

    observer.observe(target, { attributes: true });
  }
}

if (!customElements.get("product-model")) {
  customElements.define("product-model", ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener("DOMContentLoaded", () => {
  window.ProductModel?.loadShopifyXR();
});

class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    // Combined listings: recomputed per change inside getSelectedValuesIds
    this.connectedProductURL = null;

    const selectedValuesIds = this.getSelectedValuesIds();
    const requestUrl = this.createRequestUrl({
      selectedValuesIds: selectedValuesIds,
      connectedProductURL: this.connectedProductURL,
    });
    if (!requestUrl) return;

    this.fetchProductInfo(requestUrl);
    this.resetErrorMessage();
  }

  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls.map((control) => {
      const checkedInput = control.querySelector('input[type="radio"]:checked');

      // Combined listings: a checked value may belong to a connected product —
      // its url is then used for the request and the section is fully re-rendered
      if (
        checkedInput?.dataset?.productUrl &&
        checkedInput.dataset.productUrl !== this.dataset.url
      ) {
        this.connectedProductURL = checkedInput.dataset.productUrl;
      }
      return checkedInput?.dataset?.optionValueId
        ? checkedInput.dataset.optionValueId
        : null;
    });
  }

  createRequestUrl({ selectedValuesIds = [], connectedProductURL = "" }) {
    const productUrl = connectedProductURL || `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (selectedValuesIds.length) {
      const params = [];
      params.push(`section_id=${sectionId}`);
      params.push(`option_values=${selectedValuesIds.join(",")}`);
      return `${productUrl}?${params.join("&")}`;
    }
  }

  fetchProductInfo(requestUrl) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const requestController = this.abortController;

    this.toggleButtonsLoading(true);

    fetch(requestUrl, { signal: requestController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        try {
          this.setCurrentVariantAfterFetch(html);

          // Combined listings: subsequent requests and the page URL must
          // target the connected product
          if (this.connectedProductURL) {
            this.dataset.url = this.connectedProductURL;
          }

          this.updateURL();
          this.updateVariantInput();
          this.updatePickupAvailability();

          if (
            this.currentVariant?.featured_media &&
            this.dataset?.variantMediaDisplay === "show_all"
          ) {
            // If variant display != "show_all", the media gallery element is fully replaced inside updateElementsAfterFetch
            const mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
            this.updateMedia(mediaId);
          }
        } catch (err) {}

        this.updateElementsAfterFetch(html);

        if (!this.currentVariant) {
          this.setUnavailable();
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut
          );
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        if (this.abortController === requestController) {
          this.toggleButtonsLoading(false);
        }
      });
  }

  updateMedia(mediaId) {
    if (!mediaId) return;

    const mediaEl = document.querySelector(
      `[data-section="product-media-${this.dataset.section}"]`
    );
    if (!mediaEl) return;

    const isQuickView = !!this.closest("quick-view-modal");

    // Quick view stacked (desktop): pin the variant media on top via order —
    // the only QV-specific path; the QV slider reuses the shared slider branch
    if (isQuickView && window.innerWidth >= 990) {
      const qvStackedEl = mediaEl.querySelector(
        ".product__media-list[data-quick-view-type='stacked']"
      );
      if (qvStackedEl) {
        qvStackedEl
          .querySelectorAll("[data-media-id].product__media-item")
          .forEach((mediaItem) => {
            const mediaItemId = mediaItem.dataset?.mediaId;
            if (mediaItemId === mediaId) {
              mediaItem.classList.add("stacked-or-grid-active");
            } else {
              mediaItem.classList.remove("stacked-or-grid-active");
            }
          });
        return;
      }
    }

    // for slider and slider_previews layout (the quick-view slider too — in QV
    // the swiper mounts on the media list even without the slider classes)
    const sliderEl =
      mediaEl.querySelector(".js-media-list") ||
      mediaEl.querySelector(".product__media-list[data-quick-view-type]");
    if (sliderEl && sliderEl.swiper) {
      const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
      const speed = slideCount > 32 ? 0 : 800;
      const swiperSlideIndex = sliderEl.swiper.slides.findIndex(
        (slide) => slide.dataset?.mediaId === mediaId
      );
      if (swiperSlideIndex !== -1) {
        sliderEl.swiper.slideTo(swiperSlideIndex, speed);
      }
    }

    // stacked / stacked_previews / framed_stacked / grid layouts are desktop-only
    if (isQuickView || window.innerWidth < 990) return;

    // framed_stacked: scroll its own frame to the variant media (the page stays
    // put); the scroll-spy follows with the thumb highlight — no class pinning
    const framedGalleryEl = mediaEl.querySelector(
      ".product__media-list[data-desktop-type='framed_stacked']"
    );
    if (framedGalleryEl) {
      const mediaScrollRoot = mediaEl.querySelector(
        ".product__media-list-wrapper"
      );
      if (!mediaScrollRoot) return;
      framedGalleryEl
        .querySelectorAll("[data-media-id].product__media-item")
        .forEach((mediaItem) => {
          if (mediaItem.dataset?.mediaId !== mediaId) return;
          const rootRect = mediaScrollRoot.getBoundingClientRect();
          const mediaRect = mediaItem.getBoundingClientRect();
          const top =
            mediaScrollRoot.scrollTop + (mediaRect.top - rootRect.top);
          mediaScrollRoot.scrollTo({
            top: Math.max(0, top),
            behavior: "smooth",
          });
        });
      return;
    }

    // stacked / stacked_previews / grid: pin the variant media on top via order
    const noSliderGalleryEl =
      mediaEl.querySelector(
        ".product__media-list[data-desktop-type='stacked_previews']"
      ) ||
      mediaEl.querySelector(
        ".product__media-list[data-desktop-type='stacked']"
      ) ||
      mediaEl.querySelector(".product__media-list[data-desktop-type='grid']");
    if (noSliderGalleryEl) {
      noSliderGalleryEl
        .querySelectorAll("[data-media-id].product__media-item")
        .forEach((mediaItem) => {
          const mediaItemId = mediaItem.dataset?.mediaId;
          if (mediaItemId === mediaId) {
            mediaItem.classList.add("stacked-or-grid-active");
          } else {
            mediaItem.classList.remove("stacked-or-grid-active");
          }
        });
    }

    const noSliderGallerySublistEl = mediaEl.querySelector(
      ".product__media-sublist[data-desktop-type='stacked_previews']"
    );
    if (noSliderGallerySublistEl) {
      noSliderGallerySublistEl
        .querySelectorAll("[data-media-sub-id].product__media-subitem")
        .forEach((mediaItem) => {
          const mediaItemId = mediaItem.dataset?.mediaSubId;
          if (mediaItemId === mediaId) {
            mediaItem.classList.add("stacked-active");
            mediaItem.classList.add("active");
          } else {
            mediaItem.classList.remove("stacked-active");
            mediaItem.classList.remove("active");
          }
        });
    }
  }

  updateURL() {
    if (this.dataset.updateUrl === "false") return;
    const newUrl = this.currentVariant
      ? `${this.dataset.url}?variant=${this.currentVariant.id}`
      : this.dataset.url;

    window.history.replaceState({}, "", newUrl);
  }

  updateVariantInput() {
    if (!this.currentVariant?.id) return;

    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));

      // Forms without a visible quantity selector (sticky bar / hidden
      // selector) carry a hidden quantity input — keep it at the variant's
      // minimum orderable quantity so add to cart passes the quantity rules
      const hiddenQuantityInput = productForm.querySelector(
        'input[type="hidden"][name="quantity"]'
      );
      if (hiddenQuantityInput) {
        const quantityRule = this.currentVariant.quantity_rule;
        hiddenQuantityInput.value = Math.max(
          quantityRule?.min || 1,
          quantityRule?.increment || 1
        );
      }
    });

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });

    // [Start theme custom event] - Variant change event
    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: {
          variant: this.currentVariant,
          previousVariant: this.previousVariant || null,
          formElement: this,
          sectionId: this.dataset.section,
        },
      })
    );

    this.previousVariant = this.currentVariant;
    // [End theme custom event] - Variant change event
  }

  updatePickupAvailability() {
    const productInfo = document.getElementById(
      `ProductInfo-${this.dataset.section}`
    );
    const pickUpAvailability = productInfo?.querySelector(
      "pickup-availability"
    );
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  toggleAddButton(disable = true, text) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      const addButtonText =
        addButton.querySelector(".button__label") ||
        addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text) {
          addButtonText.textContent = text;

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
        addButton.dataset.status = "available";
      }
    });
  }

  resetErrorMessage() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #sticky-bar-product-form-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const parentEl = productForm.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  toggleButtonsLoading(loading) {
    const buttonsWrapper = this.closest(".product")?.querySelector(
      `#ProductButtons-${this.dataset.section}`
    );
    if (!buttonsWrapper) return;
    buttonsWrapper.classList.toggle("loading", loading);
  }

  setUnavailable() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(
      `price-sticky-${this.dataset.section}`
    );
    const badges = document.getElementById(`badges-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${this.dataset.section}"]`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    if (price) price.classList.add("visibility-hidden");
    if (priceSticky) priceSticky.classList.add("visibility-hidden");
    if (badges) badges.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  updateElementsAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const quickViewModal = this.closest("quick-view-modal");

    // price
    const priceDestination = document.getElementById(
      `price-${currentSectionId}`
    );
    const priceStickyDestination = document.getElementById(
      `price-sticky-${currentSectionId}`
    );
    const priceSource = html.getElementById(`price-${sourceSectionId}`);
    if (priceSource && priceDestination) {
      priceDestination.innerHTML = priceSource.innerHTML;
      priceDestination.classList.remove("visibility-hidden");
    }
    if (priceSource && priceStickyDestination) {
      priceStickyDestination.innerHTML = priceSource.innerHTML;
      const priceText = priceStickyDestination.querySelector(".price-text");
      if (priceText) priceText.className = "price-text";
    }

    // badges
    const badgesSource = html.getElementById(`badges-${sourceSectionId}`);
    const badgesDestination = document.getElementById(
      `badges-${currentSectionId}`
    );
    if (badgesSource && badgesDestination) {
      badgesDestination.innerHTML = badgesSource.innerHTML;
      badgesDestination.classList.remove("visibility-hidden");
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = document.getElementById(
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText.trim() === "" ||
          inventorySource.classList.contains("visibility-hidden")
      );
    }

    // sku
    const skuSource = html.getElementById(`Sku-${sourceSectionId}`);
    const skuDestination = document.getElementById(`Sku-${currentSectionId}`);
    if (skuSource && skuDestination) {
      skuDestination.innerHTML = skuSource.innerHTML;
      skuDestination.classList.toggle(
        "visibility-hidden",
        skuSource.classList.contains("visibility-hidden")
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant picker options — the fetched markup carries the actual
    // availability/selected states computed by Shopify for this selection
    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${currentSectionId}`
    );
    if (variantPickerSource && variantPickerDestination) {
      const sourceOptionValues = variantPickerSource.querySelectorAll(
        `[id^="OptionValues-${sourceSectionId}-"]`
      );

      if (sourceOptionValues.length && !this.connectedProductURL) {
        sourceOptionValues.forEach((sourceOptionsEl) => {
          const position = sourceOptionsEl.dataset.optionPosition;
          if (!position) return;
          const destOptionsEl = variantPickerDestination.querySelector(
            `[data-option-position="${position}"][id^="OptionValues-"]`
          );
          if (destOptionsEl) {
            destOptionsEl.innerHTML = quickViewModal
              ? sourceOptionsEl.innerHTML.replaceAll(
                  sourceSectionId,
                  `quickview-${sourceSectionId}`
                )
              : sourceOptionsEl.innerHTML;
          }
        });
      } else {
        // fallback to replace whole variant picker html (Combined listings —
        // the option set belongs to the connected product)
        variantPickerDestination.innerHTML = quickViewModal
          ? variantPickerSource.innerHTML.replaceAll(
              sourceSectionId,
              `quickview-${sourceSectionId}`
            )
          : variantPickerSource.innerHTML;

        // Force reflow to prevent Safari iOS fieldset rendering issues.
        requestAnimationFrame(() => {
          variantPickerDestination
            .querySelectorAll("fieldset.product-form__controls")
            .forEach((fieldset) => {
              fieldset.style.display = "grid";
              void fieldset.offsetHeight;
              fieldset.style.display = "";
            });
        });
      }
    }

    // Update elements for B2B quantity pricing https://help.shopify.com/en/manual/b2b/catalogs/quantity-pricing
    const productButtonsSource = html.getElementById(
      `ProductButtons-${sourceSectionId}`
    );
    const productButtonsDestination = document.getElementById(
      `ProductButtons-${currentSectionId}`
    );
    if (productButtonsSource && productButtonsDestination) {
      const sourceButtonsWrapper = productButtonsSource.querySelector(
        ".product-form__buttons"
      );
      const buttonsWrapper = productButtonsDestination.querySelector(
        ".product-form__buttons"
      );

      if (sourceButtonsWrapper && buttonsWrapper) {
        const sourceHasQuantityPricing =
          sourceButtonsWrapper.dataset.hasQuantityPricing === "true";
        const destHadQuantityPricing =
          buttonsWrapper.dataset.hasQuantityPricing === "true";

        // This branch is executed only if quantity pricing is configured for the product or product variant
        if (sourceHasQuantityPricing || destHadQuantityPricing) {
          if (sourceHasQuantityPricing) {
            buttonsWrapper.dataset.hasQuantityPricing = "true";
          } else {
            buttonsWrapper.removeAttribute("data-has-quantity-pricing");
          }

          const prepareHtml = (el) => {
            return quickViewModal
              ? el.innerHTML.replaceAll(
                  sourceSectionId,
                  `quickview-${sourceSectionId}`
                )
              : el.innerHTML;
          };

          // Update b2b elements (volume pricing + quantity rules)
          const sourceB2bEl = sourceButtonsWrapper.querySelector(
            ".product-b2b-elements"
          );
          const destB2bEl = buttonsWrapper.querySelector(
            ".product-b2b-elements"
          );
          if (sourceB2bEl && destB2bEl) {
            destB2bEl.innerHTML = prepareHtml(sourceB2bEl);
          } else if (sourceB2bEl && !destB2bEl) {
            buttonsWrapper.insertAdjacentHTML(
              "afterbegin",
              sourceB2bEl.outerHTML
            );
          } else if (!sourceB2bEl && destB2bEl) {
            destB2bEl.remove();
          }

          // Update quantity input (min/max/step follow the variant quantity rules)
          const sourceQuantityWrapper = sourceButtonsWrapper.querySelector(
            ".product-form__quantity"
          );
          const destQuantityWrapper = buttonsWrapper.querySelector(
            ".product-form__quantity"
          );
          if (sourceQuantityWrapper && destQuantityWrapper) {
            destQuantityWrapper.innerHTML = prepareHtml(sourceQuantityWrapper);
          }
        }
      }
    }

    // product media
    // Product media is replaced with DOM changes and gallery re-initialization
    // only when Variant media display is not set to "Show all" or when a product
    // is linked to the variant (e.g., via Combined listings).
    // In most other cases, it updates via updateMedia without DOM changes.
    if (
      this.dataset?.variantMediaDisplay !== "show_all" ||
      this.connectedProductURL
    ) {
      const mediaSource = html.querySelector(
        `[data-section="product-media-${sourceSectionId}"]`
      );
      const mediaDestination = document.querySelector(
        `[data-section="product-media-${currentSectionId}"]`
      );
      if (mediaSource && mediaDestination) {
        mediaDestination.innerHTML = mediaSource.innerHTML;

        const parentFeaturedProduct = this.closest(".featured-product-section");
        if (quickViewModal) {
          if (typeof quickViewModal.removeDOMElements === "function") {
            quickViewModal.removeDOMElements(mediaDestination);
          }
          if (typeof quickViewModal.initSlider === "function") {
            quickViewModal.initSlider();
          }
        } else {
          // Update zoom modal for Combined listings — it was moved to body by
          // ModalDialog.connectedCallback, so it is replaced separately
          if (this.connectedProductURL) {
            const zoomModalSource = html.querySelector(
              `#ProductModal-${sourceSectionId}`
            );
            const zoomModalDest = document.querySelector(
              `#ProductModal-${currentSectionId}`
            );

            if (zoomModalSource && zoomModalDest) {
              const newZoomModal = zoomModalSource.cloneNode(true);
              newZoomModal.id = `ProductModal-${currentSectionId}`;
              zoomModalDest.replaceWith(newZoomModal);
            }
          }

          const section = document.getElementById(
            `shopify-section-${currentSectionId}`
          );

          if (section && parentFeaturedProduct) {
            if (typeof window.initFeaturedProduct === "function") {
              window.initFeaturedProduct(section);
            }
          } else if (section && typeof initProductPage === "function") {
            initProductPage(section);
          }
        }
      }
    }

    // Replace other product info elements for Combined listings
    if (this.connectedProductURL) {
      const productInfoSrc = html.getElementById(
        `ProductInfo-${sourceSectionId}`
      );
      const productInfoDest = document.getElementById(
        `ProductInfo-${currentSectionId}`
      );
      if (productInfoSrc && productInfoDest) {
        // Title
        const titleSrc = productInfoSrc.querySelector(".product__title");
        const titleDest = productInfoDest.querySelectorAll(".product__title");
        if (titleSrc) {
          titleDest.forEach((el) => {
            el.innerHTML = titleSrc.innerHTML;
          });
        }

        // Sticky add to cart bar title
        const stickyTitleDest = document.querySelectorAll(
          ".product-sticky-add-bar__title"
        );
        if (titleSrc) {
          stickyTitleDest.forEach((el) => {
            el.innerHTML = titleSrc.innerText;
          });
        }

        // Description
        const descriptionSrc = productInfoSrc.querySelector(
          ".product__description"
        );
        const descriptionDest = productInfoDest.querySelectorAll(
          ".product__description"
        );
        if (descriptionSrc) {
          descriptionDest.forEach((el) => {
            el.innerHTML = descriptionSrc.innerHTML;
          });
        }

        // Complementary products
        const complementaryProductsSrc = productInfoSrc.querySelector(
          "product-recommendations.complementary-products"
        );
        const complementaryProductsDest = productInfoDest.querySelectorAll(
          "product-recommendations.complementary-products"
        );
        if (complementaryProductsSrc) {
          complementaryProductsDest.forEach((el) => {
            el.replaceWith(complementaryProductsSrc.cloneNode(true));
          });
        }
      }
    }
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestionation = document.getElementById(
      `variant-picker-${this.dataset.section}`
    );
    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = newVariantDataEl.innerHTML;

    const selectedVariant = !!newVariantData
      ? JSON.parse(newVariantData)
      : null;

    this.currentVariant = selectedVariant;

    const oldEl = variantPickerDestionation?.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.innerHTML = newVariantData;
    }
  }
}

if (!customElements.get("variant-picker")) {
  customElements.define("variant-picker", VariantPicker);
}

class VariantDropdownSelect extends HTMLElement {
  constructor() {
    super();

    this.currentEl = this.querySelector(".dropdown-select__current");
    this.optionsWrapperEl = this.querySelector(".dropdown-select__options");
    this.hiddenInput = this.querySelector("input[type='hidden']");
    if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) return;

    this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll("li"));
    this.inputs = Array.from(this.optionsWrapperEl.querySelectorAll("input"));
    this.hasColorSwatch = this.currentEl?.classList?.contains(
      "dropdown-select__current--with-color"
    );
    this.isActive = false;

    this.optionPosition = this.getOptionPosition();
    this._onCurrentClick = this.onCurrentClick.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this._onOptionsClick = this.onClickOption.bind(this);
    this._onKeyUpOptions = this.onKeyUpOptions.bind(this);
    this._onKeyDownOptions = this.onKeyDownOptions.bind(this);
    this._onOutsideClick = this.onOutsideClick.bind(this);
  }

  connectedCallback() {
    this.currentEl.addEventListener("click", this._onCurrentClick);
    this.currentEl.addEventListener("keyup", this._onKeyUp);
    this.currentEl.addEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.addEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.addEventListener("keyup", this._onKeyUpOptions);
    this.optionsWrapperEl.addEventListener("keydown", this._onKeyDownOptions);
    document.addEventListener("click", this._onOutsideClick);
  }

  disconnectedCallback() {
    this.currentEl.removeEventListener("click", this._onCurrentClick);
    this.currentEl.removeEventListener("keyup", this._onKeyUp);
    this.currentEl.removeEventListener("dblclick", this.preventDoubleClick);
    this.optionsWrapperEl.removeEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.removeEventListener("keyup", this._onKeyUpOptions);
    this.optionsWrapperEl.removeEventListener(
      "keydown",
      this._onKeyDownOptions
    );
    document.removeEventListener("click", this._onOutsideClick);
  }

  onCurrentClick(event) {
    event.stopPropagation();
    if (this.isActive) {
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() === "ENTER") {
      event.preventDefault();
      event.stopPropagation();
      // Swallow the Enter keyup that follows selecting an option by keyboard:
      // selectOption already closed the dropdown and moved focus here, so this
      // keyup must not re-open it.
      if (this._suppressNextEnterKeyup) {
        this._suppressNextEnterKeyup = false;
        return;
      }
      if (this.isActive) {
        this.onClose();
      } else {
        this.onOpen();
      }
    }
  }

  preventDoubleClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onClickOption(event) {
    // Cancel native <label> activation; we set the radio checked ourselves so
    // there is no race with closing the dropdown (which would suppress it).
    event.preventDefault();
    const optionEl = event.target.closest("li");
    if (!optionEl || !this.optionsWrapperEl.contains(optionEl)) return;
    this.selectOption(optionEl);
  }

  selectOption(optionEl) {
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );
    const newInput = optionEl?.querySelector('input[type="radio"]');
    if (!optionEl || !currentValueEl || !newInput) return;

    const newValue = optionEl.dataset.value;
    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    if (this.hasColorSwatch) {
      const newColor = optionEl.dataset.color;
      this.hiddenInput.dataset.colorSwatch = newColor;
      this.currentEl.style.setProperty("--swatch-color", newColor);
    }

    // Set the checked state (property + attribute) authoritatively BEFORE
    // dispatching change so VariantPicker.getSelectedValuesIds reads this value.
    this.inputs.forEach((el) => {
      el.checked = false;
      el.removeAttribute("checked");
    });
    newInput.checked = true;
    newInput.setAttribute("checked", "checked");

    this.hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));

    this.onClose();
    this.currentEl.focus();
  }

  onKeyUpOptions(event) {
    if (event.code === "Escape" && this.isActive) {
      event.preventDefault();
      this.onClose();
      this.currentEl.focus();
    }
  }

  onKeyDownOptions(event) {
    if (!this.isActive) return;
    const items = this.inputs;
    if (!items.length) return;
    const idx = items.indexOf(document.activeElement);

    switch (event.key) {
      case "Tab": {
        // Trap focus inside the open listbox (roving) instead of letting it
        // escape to the next focusable element on the page.
        event.preventDefault();
        const dir = event.shiftKey ? -1 : 1;
        let next = idx + dir;
        if (next < 0) next = items.length - 1;
        if (next > items.length - 1) next = 0;
        items[next].focus();
        break;
      }
      case "ArrowDown":
        event.preventDefault();
        items[idx >= items.length - 1 ? 0 : idx + 1].focus();
        break;
      case "ArrowUp":
        event.preventDefault();
        items[idx <= 0 ? items.length - 1 : idx - 1].focus();
        break;
      case "Home":
        event.preventDefault();
        items[0].focus();
        break;
      case "End":
        event.preventDefault();
        items[items.length - 1].focus();
        break;
      case "Enter":
      case " ":
      case "Spacebar": {
        event.preventDefault();
        const li = document.activeElement?.closest("li");
        if (li && this.optionsWrapperEl.contains(li)) {
          this.selectOption(li);
          // Enter's trailing keyup lands on currentEl; flag it so onKeyUp
          // does not toggle the dropdown back open.
          if (event.key === "Enter") this._suppressNextEnterKeyup = true;
        }
        break;
      }
      case "Escape":
        event.preventDefault();
        this.onClose();
        this.currentEl.focus();
        break;
    }
  }

  onOpen() {
    document.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (dropdown !== this && typeof dropdown.onClose === "function") {
        dropdown.onClose();
      }
    });

    this.optionsWrapperEl.classList.add("active");
    this.currentEl.setAttribute("aria-expanded", "true");
    this.isActive = true;

    const currentIndex = this.inputs.findIndex((inp) =>
      inp.hasAttribute("checked")
    );
    this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus();
  }

  onClose() {
    this.optionsWrapperEl.classList.remove("active");
    this.currentEl.setAttribute("aria-expanded", "false");
    this.isActive = false;
  }

  onOutsideClick(event) {
    if (!this.isActive || this.contains(event.target)) return;
    this.onClose();
  }

  getOptionPosition() {
    const parentFieldset = this.closest(".product-form__controls");
    return Number(parentFieldset?.dataset?.optionPosition || -1);
  }

  updateCurrentOption(selectedValues = []) {
    // Method is used to synchronize after changes options in sticky bar.
    if (this.optionPosition === -1) return;
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (!currentValueEl || !selectedValues || !selectedValues.length) return;

    const newValue = selectedValues[this.optionPosition - 1];

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    this.optionsEls.forEach((optionEl) => {
      const liDataValue = optionEl.dataset.value;
      if (newValue === liDataValue && this.hasColorSwatch) {
        const newColor = optionEl.dataset.color;
        this.hiddenInput.dataset.colorSwatch = newColor;
        this.currentEl.style.setProperty("--swatch-color", newColor);
      }
    });
  }
}

if (!customElements.get("variant-dropdown-select")) {
  customElements.define("variant-dropdown-select", VariantDropdownSelect);
}

class ProductForm extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector("form")) {
      this.form = this.querySelector("form");
      this.form.querySelector("[name=id]").disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    } else {
      this.querySelector("[name=id]").disabled = false;
      this.querySelector("button[type=submit]").addEventListener(
        "click",
        this.onSubmitHandler.bind(this)
      );
    }

    this.cartUIElement = document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    if (this.cartUIElement) {
      this.submitButton.setAttribute("aria-haspopup", "dialog");
    }

    this.hideErrors = this.dataset.hideErrors === "true";
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("loading");

    const btnSpinner = this.submitButton.querySelector(
      ".loading-overlay__spinner"
    );
    if (btnSpinner) btnSpinner.classList.remove("hidden");

    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    const formData = new FormData(this.form);
    if (!this.form) {
      formData.append("id", this.querySelector("[name=id]").value);
    }

    if (this.cartUIElement) {
      formData.append(
        "sections",
        this.cartUIElement.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        // If there is a status in the response, then this is an error
        // https://shopify.dev/docs/api/ajax/reference/cart#error-responses
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: response.errors || response.description,
            message: response.message,
          });

          // [Start theme custom event] - Cart error event
          document.dispatchEvent(
            new CustomEvent("cart:error", {
              detail: {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              },
            })
          );
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          // [End theme custom event] - Cart error event

          this.handleErrorMessage(response.description);
          const soldOutMessage =
            this.submitButton.querySelector(".sold-out-message");
          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        } else if (!this.cartUIElement) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) {
          // [Start theme custom event] - Variant addition event
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: response.variant_id || formData.get("id"),
                  quantity:
                    response.quantity || Number(formData.get("quantity") || 1),
                  product_title: response.product_title || "",
                  variant_title: response.variant_title || "",
                  image: response.image || null,
                },
                formElement: this.form,
              },
            })
          );
          // [End theme custom event] - Variant addition event

          // [Start theme custom event] - Cart change event
          fetch(`${routes.cart_url}.js`)
            .then((r) => r.json())
            .then((cartState) => {
              document.dispatchEvent(
                new CustomEvent("cart:change", {
                  detail: { cart: cartState },
                })
              );
            })
            .catch((e) => console.error("cart:change fetch error:", e));
          // [End theme custom event] - Cart change event

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
          });
        }
        this.error = false;

        let activeElement = document.activeElement;

        // add to cart from quick-view modal
        const quickAddModal = this.closest("quick-view-modal");
        if (quickAddModal && typeof quickAddModal?.hide === "function") {
          activeElement = quickAddModal.openedBy;
          document.body.addEventListener(
            "quick-view-closed",
            () => {
              setTimeout(() => {
                this.cartUIElement.setActiveElement(activeElement);
                this.cartUIElement.renderContents(response);
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
          return;
        }

        // add to cart from product card
        const productCard = this.closest("product-card");
        if (productCard) {
          const link = productCard.querySelector(".product-card__link-overlay");
          if (link) activeElement = link;
        }

        // open cart drawer after add to cart
        this.cartUIElement.setActiveElement(activeElement);
        this.cartUIElement.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove("loading");
        if (!this.error) this.submitButton.removeAttribute("aria-disabled");
        if (btnSpinner) btnSpinner.classList.add("hidden");

        // Activate close cursor
        document.querySelector("cart-drawer modal-close-cursor")?.activate();
      });
  }

  handleErrorMessage(errorMessage = "") {
    if (this.hideErrors) return;

    const errorWrapperEl = this.querySelector(
      ".product-form__error-message-wrapper"
    );
    const errorTextEl =
      errorWrapperEl?.querySelector(".product-form__error-message") ||
      errorWrapperEl;
    if (!errorWrapperEl || !errorTextEl) return;

    if (errorMessage) {
      errorWrapperEl.removeAttribute("hidden", true);
      errorTextEl.textContent = errorMessage;
    } else {
      errorWrapperEl.setAttribute("hidden", true);
      errorTextEl.textContent = "";
    }
  }
}

if (!customElements.get("product-form")) {
  customElements.define("product-form", ProductForm);
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.recommendationsSlider = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this.initProductRecommendations();
  }

  initProductRecommendations() {
    this.enableLoading();

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");
        if (recommendations && recommendations.innerHTML.trim().length) {
          //this.innerHTML = recommendations.innerHTML;
          this.replaceChildren(...recommendations.children);
        }

        this.checkSlider();
        // Markup arrives after global.js has already bound the page — re-attach.
        window.initArrowMoveOnHover?.(this, ".button--tertiary");
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.disableLoading();
        this._initialized = true;
      });
  }

  destroySlider() {
    if (
      this.recommendationsSlider &&
      typeof this.recommendationsSlider.destroy === "function"
    ) {
      this.recommendationsSlider.destroy();
    }
    this.recommendationsSlider = null;
  }

  checkSlider() {
    this.destroySlider();

    const container = this.querySelector(".js-recommendation-slider");
    if (container && typeof window.PopularProductsSection === "function") {
      this.recommendationsSlider = new window.PopularProductsSection(this);
    }
  }

  enableLoading() {
    const loadingEl = this.querySelector(".product-recommendations__loading");
    if (loadingEl) {
      loadingEl.classList.add("loading");
      loadingEl.style.display = "flex";
    }
  }

  disableLoading() {
    const loadingEl = this.querySelector(".product-recommendations__loading");
    if (loadingEl) {
      loadingEl.classList.remove("loading");
      loadingEl.remove();
    }
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      langInput: this.querySelector('input[name="locale_code"]'),
      countryInput: this.querySelector('input[name="country_code"]'),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

class ModalLocalizationForm extends LocalizationForm {
  constructor() {
    super();

    this.selectedEl = this.querySelector("button .localization-value-label");
  }

  // item click without submit
  onItemClick(event) {
    event.preventDefault();
    const newValue = event.currentTarget.dataset.value;
    if (!newValue) return;

    const newLabel = event.currentTarget.dataset.label;
    if (this.selectedEl && newLabel) {
      this.selectedEl.textContent = newLabel;
    }

    // Keep the country flag in sync with the picked country (no-op when the flag is off
    // or on the language form, where there is no flag in the toggle button).
    const flagImg = this.querySelector("button .localization-flag__img");
    const newFlag = event.currentTarget.dataset.flag;
    if (flagImg && newFlag) {
      flagImg.src = newFlag.split(",")[0].trim();
      flagImg.srcset = newFlag;
    }

    if (this.classList.contains("modal-language-form")) {
      document.querySelectorAll("modal-localization-form").forEach((el) => {
        el.elements.langInput.value = newValue;
      });
    }

    if (this.classList.contains("modal-country-form")) {
      document.querySelectorAll("modal-localization-form").forEach((el) => {
        el.elements.countryInput.value = newValue;
      });
    }

    this.hidePanel();
  }
}

if (!customElements.get("modal-localization-form")) {
  customElements.define("modal-localization-form", ModalLocalizationForm);
}

class ModalRegionSelector extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");
    this.toggle = this.querySelector(".modal-region-toggle");
    this.modalContainer = this.querySelector(".region-modal");
    this.closeButton =
      this.querySelector(".modal-close-button") ||
      this.querySelector(".mobile-submenu__back");
    this.overlayEl = this.querySelector(".modal__overlay");
    this.submitButton = this.querySelector(".localization-modal__button");
    this.languageForm = this.querySelector(".modal-language-form form");
    this.countryForm = this.querySelector(".modal-country-form form");
    this.modalType = this.dataset?.modalType || "drawer";
    this.localizationWrapper = this.querySelector(
      ".localization-modal__wrapper"
    );
    this.regionBtn = this.querySelector(
      ".localization-modal__checkbox--region"
    );
    this.languageBtn = this.querySelector(
      ".localization-modal__checkbox--language"
    );
    this.closeCursor = this.querySelector("modal-close-cursor");

    if (this.header) this.header.preventHide = false;
  }

  connectedCallback() {
    this.modalContainer?.addEventListener("keyup", this.onEscClose.bind(this));
    this.toggle?.addEventListener("click", this.onOpen.bind(this));
    this.closeButton?.addEventListener("click", this.onClose.bind(this));
    this.overlayEl?.addEventListener("click", this.onClose.bind(this));
    this.submitButton?.addEventListener("click", this.onSubmit.bind(this));
    this.regionBtn?.addEventListener(
      "click",
      this.onSwitchTab.bind(this, "region")
    );
    this.languageBtn?.addEventListener(
      "click",
      this.onSwitchTab.bind(this, "language")
    );
  }

  disconnectedCallback() {
    this.closeCursor?.deactivate();

    // Dropped from the DOM while open (theme editor re-render) — release the body scroll-lock.
    if (this.getAttribute("open")) {
      if (this.modalType !== "mobile") {
        document.body.classList.remove(`overflow-hidden-${this.modalType}`);
      }
      removeTrapFocus();
      if (this.header) this.header.preventHide = false;
    }
  }

  onSwitchTab(tab) {
    this.localizationWrapper?.setAttribute("data-show-modal", tab);
  }

  onEscClose(event) {
    if (event.code === "Escape") {
      this.onClose();
    }
  }

  onOpen() {
    this.setAttribute("open", true);
    this.modalContainer.classList.add("modal--open");
    if (this.modalType !== "mobile") {
      document.body.classList.add(`overflow-hidden-${this.modalType}`);
    }
    if (this.header) this.header.preventHide = true;

    if (this.modalContainer && this.closeButton) {
      trapFocus(this.modalContainer, this.closeButton);
    }

    this.closeCursor?.activate();
  }

  onClose() {
    this.removeAttribute("open");
    this.modalContainer.classList.remove("modal--open");
    if (this.modalType !== "mobile") {
      document.body.classList.remove(`overflow-hidden-${this.modalType}`);
    }
    if (this.header) this.header.preventHide = false;

    removeTrapFocus(this.toggle);

    this.closeCursor?.deactivate();
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.countryForm && this.countryForm?.action) {
      this.countryForm.submit();
    }

    if (this.languageForm && this.languageForm?.action) {
      this.languageForm.submit();
    }
  }
}

if (!customElements.get("modal-region-selector")) {
  customElements.define("modal-region-selector", ModalRegionSelector);
}

class ModalAccount extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector(".header-wrapper");
    this.modalContainer = this.querySelector(".account-modal");
    this.accountButton = this.querySelector(".header-account-button");
    this.closeButton =
      this.querySelector(".modal-close-button") ||
      this.querySelector(".mobile-submenu__back");
    this.overlayEl = this.querySelector(".modal__overlay");
    this.modalType = this.dataset?.modalType || "drawer";
    this.closeCursor = this.querySelector("modal-close-cursor");

    if (this.header) this.header.preventHide = false;
  }

  connectedCallback() {
    this.modalContainer?.addEventListener("keyup", this.onEscClose.bind(this));
    this.closeButton?.addEventListener("click", this.onClose.bind(this));
    this.overlayEl?.addEventListener("click", this.onClose.bind(this));
    this.accountButton?.addEventListener("click", this.onOpen.bind(this));
  }

  disconnectedCallback() {
    this.closeCursor?.deactivate();

    // Dropped from the DOM while open (theme editor re-render) — release the body scroll-lock.
    if (this.getAttribute("open")) {
      if (this.modalType !== "mobile") {
        document.body.classList.remove(`overflow-hidden-${this.modalType}`);
      }
      removeTrapFocus();
      if (this.header) this.header.preventHide = false;
    }
  }

  onEscClose(event) {
    if (event.code === "Escape") {
      this.onClose();
    }
  }

  onOpen() {
    this.setAttribute("open", true);
    this.modalContainer.classList.add("modal--open");

    if (this.modalType !== "mobile") {
      document.body.classList.add(`overflow-hidden-${this.modalType}`);
    }

    if (this.header) this.header.preventHide = true;

    if (this.modalContainer && this.closeButton) {
      trapFocus(this.modalContainer, this.closeButton);
    }

    this.closeCursor?.activate();
  }

  onClose() {
    this.removeAttribute("open");
    this.modalContainer.classList.remove("modal--open");

    if (this.modalType !== "mobile") {
      document.body.classList.remove(`overflow-hidden-${this.modalType}`);
    }

    if (this.header) this.header.preventHide = false;

    removeTrapFocus(this.toggle);

    this.closeCursor?.deactivate();
  }
}

if (!customElements.get("modal-account")) {
  customElements.define("modal-account", ModalAccount);
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetBtn = this.querySelector(".search-reset-button");

    this.input?.form?.addEventListener("reset", this.onFormReset.bind(this));
    this.input?.addEventListener(
      "input",
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.resetBtn?.addEventListener("click", this.onFormReset.bind(this));
  }

  toggleResetBtn(value) {
    if (!this.resetBtn) return;

    if (value) {
      this.resetBtn.style.display = "flex";
    } else {
      this.resetBtn.style.display = "";
    }
  }

  onChange(event) {
    this.toggleResetBtn(event.target.value);
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm() && this.input) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetBtn("");
    }
  }
}

if (!customElements.get("search-form")) {
  customElements.define("search-form", SearchForm);
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.closeBtn = this.mainDetailsToggle?.querySelector(
      ".modal__heading > .modal-close-button"
    );
    this.backBtn =
      this.mainDetailsToggle?.querySelector(
        "summary + .mobile-submenu > .mobile-submenu__back"
      ) ||
      this.mainDetailsToggle?.querySelector(
        "summary + .burger-menu__submenu > .burger-menu__submenu-back"
      );
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.closeBtn?.addEventListener(
      "click",
      this.onCloseButtonClick.bind(this)
    );
    this.backBtn?.addEventListener("click", this.onCloseButtonClick.bind(this));
  }

  disconnectedCallback() {
    // Dropped from the DOM while open (theme editor re-render) — release the body scroll-lock.
    // Drawers nested in burger-menu / header-drawer never locked the body (see openMenuDrawer);
    // their parent components clean up after themselves.
    if (
      this.mainDetailsToggle?.hasAttribute("open") &&
      !this.closest("header-drawer") &&
      !this.closest("burger-menu")
    ) {
      document.body.classList.remove("overflow-hidden");
      removeTrapFocus();
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    if (!this.closest("header-drawer") && !this.closest("burger-menu")) {
      document.body.classList.add(`overflow-hidden`);
    }
  }

  closeMenuDrawer(elementToFocus) {
    //if (!elementToFocus) return;
    this.mainDetailsToggle.classList.remove("menu-opening");

    if (!this.closest("burger-menu")) {
      // in desktop burger all <details> elements are always open
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
        details.querySelector("summary").setAttribute("aria-expanded", false);
      });
    }

    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);

    document.body.classList.remove("overflow-hidden");
    if (elementToFocus) removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

if (!customElements.get("menu-drawer")) {
  customElements.define("menu-drawer", MenuDrawer);
}

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector(".shopify-section-header");
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.openBtn = this.querySelector("summary.menu-drawer-icon");
    this.closeBtn = this.querySelector("#mobile-menu-close-btn");
    this.isOpen = false;

    this.closeBtn?.addEventListener("click", () => {
      this.closeMenuDrawer(this.openBtn);
    });
  }

  disconnectedCallback() {
    // Dropped from the DOM while open (theme editor re-render) — release the body scroll-lock.
    if (!this.isOpen) return;
    document.body.classList.remove("overflow-hidden-mobile-menu");
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus();
    if (this.iosTimeoutId) clearTimeout(this.iosTimeoutId);
    this.unlockScorllBodyOnIos();
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
  }

  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("overflow-hidden-mobile-menu");
    this.isOpen = true;
    this.openScrollY = window.scrollY;

    // styles for forced disable body scroll on iOS
    this.lockScrollBodyOnIos();
  }

  closeMenuDrawer(elementToFocus) {
    if (!elementToFocus) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.querySelector("header-search")?.close();
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    document.body.classList.remove("overflow-hidden-mobile-menu");
    document.body.classList.remove("overflow-hidden");
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    // styles for forced disable body scroll on iOS
    this.unlockScorllBodyOnIos();

    if (this.headerWrapper) this.headerWrapper.preventHide = false;
    this.isOpen = false;
  }

  lockScrollBodyOnIos() {
    if (navigator.userAgent.indexOf("iPhone") > -1) {
      if (this.iosTimeoutId) clearTimeout(this.iosTimeoutId);
      if (
        this.headerWrapper &&
        typeof this.headerWrapper.disableScroll === "function"
      ) {
        this.headerWrapper.disableScroll();
      }
      document.documentElement.style.setProperty(
        "--current-body-scroll",
        `${-1 * this.openScrollY}px`
      );
      document.documentElement.style.setProperty("scroll-behavior", "unset");

      this.iosTimeoutId = setTimeout(function () {
        document.body.classList.add("forced-scroll-locked");
      }, 400);
    }
  }

  unlockScorllBodyOnIos() {
    if (navigator.userAgent.indexOf("iPhone") > -1) {
      document.body.classList.remove("forced-scroll-locked");
      //window.scrollTo(0, this.openScrollY);
      document.documentElement.scrollTop = this.openScrollY;
      document.documentElement.style.removeProperty("--current-body-scroll");
      document.documentElement.style.removeProperty("scroll-behavior");
      if (
        this.headerWrapper &&
        typeof this.headerWrapper.enableScroll === "function"
      ) {
        this.headerWrapper.enableScroll();
      }
    }
  }
}

if (!customElements.get("header-drawer")) {
  customElements.define("header-drawer", HeaderDrawer);
}

// ADD ARROW MOVE ANIMATION ON HOVER
// -----------------------------------------------------------------------------

function initArrowMoveOnHover(parent, classElement) {
  if (!parent) return;

  const handleEnter = (event) => {
    const element = event.currentTarget;
    element.classList.remove("hover-inactive");
    element.classList.add("hover-active");
  };

  const handleLeave = (event) => {
    const element = event.currentTarget;
    element.classList.remove("hover-active");
    element.classList.add("hover-inactive");
  };

  const elements = parent.querySelectorAll(classElement);

  if (elements.length) {
    elements.forEach((element) => {
      if (element.dataset.arrowHoverInit === "true") {
        return;
      }
      element.dataset.arrowHoverInit = "true";
      element.addEventListener("mouseenter", handleEnter);
      element.addEventListener("mouseleave", handleLeave);
      element.addEventListener("focus", handleEnter);
      element.addEventListener("blur", handleLeave);
    });
  }
}

initArrowMoveOnHover(
  document,
  ".button--tertiary, .collection-card, .interactive-collections__block, .promo-card, .media-banner__wrapper--has-link"
);
window.initArrowMoveOnHover = initArrowMoveOnHover;
document.addEventListener("shopify:section:load", function (event) {
  initArrowMoveOnHover(
    event.target,
    ".button--tertiary, .media-banner__wrapper--has-link"
  );
});

// CURSOR-FOLLOW SLIDER NAV
// -----------------------------------------------------------------------------

// Wires one `.cursor-arrow-zone`: the pill inside trails the pointer, flips prev/next by the
// pointer side (or keeps the zone's fixed `data-direction`) and the zone itself takes the click.
// Returns `{ sync, destroy }` — `sync` re-checks the inert end after a slide change.
function initCursorArrowZone(zone, options) {
  const inert = { sync: () => {}, destroy: () => {} };
  if (!zone || zone.dataset.cursorArrowInit === "true") return inert;

  const arrow = zone.querySelector(".cursor-arrow");
  const onNavigate = options?.onNavigate;
  if (!arrow || typeof onNavigate !== "function") return inert;

  const isEndReached = options.isEndReached;
  const isSuppressed = options.isSuppressed;
  // A one-way zone (two of them flanking centred content) keeps its own direction
  const fixedDirection = zone.dataset.direction || null;
  const rtl = document.documentElement.getAttribute("dir") === "rtl";
  const reduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const EASE = 0.2;
  // Resting inset from the zone edges; the zone still catches the pointer up to its edge
  const EDGE_GAP = 24;

  let direction = fixedDirection === "prev" ? "prev" : "next";
  let targetX = 0;
  let targetY = 0;
  let currentX = 0;
  let currentY = 0;
  let rafId = null;
  let entered = false;

  const clamp = (value, min, max) =>
    Math.max(min, Math.min(value, Math.max(min, max)));

  const directionAt = (clientX, rect) => {
    if (fixedDirection) return direction;
    const isLeftHalf = clientX < rect.left + rect.width / 2;
    return (rtl ? !isLeftHalf : isLeftHalf) ? "prev" : "next";
  };

  const syncState = () => {
    const disabled =
      typeof isEndReached === "function" && isEndReached(direction) === true;
    zone.classList.toggle("is-disabled", disabled);
  };

  const setDirection = (next) => {
    if (next === direction) return;
    direction = next;
    arrow.classList.toggle("is-prev", direction === "prev");
    arrow.classList.toggle("is-next", direction === "next");
    syncState();
  };

  const updateTarget = (clientX, clientY, rect) => {
    const width = arrow.offsetWidth;
    const height = arrow.offsetHeight;
    targetX = clamp(
      clientX - rect.left - width / 2,
      EDGE_GAP,
      rect.width - width - EDGE_GAP
    );
    targetY = clamp(
      clientY - rect.top - height / 2,
      EDGE_GAP,
      rect.height - height
    );
  };

  const applyTransform = () => {
    // `translate`, not `transform` — `scale` stays free for the CSS entrance
    arrow.style.translate = `${currentX}px ${currentY}px`;
  };

  const tick = () => {
    currentX += (targetX - currentX) * EASE;
    currentY += (targetY - currentY) * EASE;
    applyTransform();
    rafId = requestAnimationFrame(tick);
  };

  const stopLoop = () => {
    if (rafId != null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  const syncSuppressed = (event) => {
    if (typeof isSuppressed !== "function") return;
    zone.classList.toggle(
      "is-suppressed",
      isSuppressed(event.clientX, event.clientY, event) === true
    );
  };

  const handleEnter = (event) => {
    entered = true;
    const rect = zone.getBoundingClientRect();
    setDirection(directionAt(event.clientX, rect));
    updateTarget(event.clientX, event.clientY, rect);
    syncSuppressed(event);
    // Snap to the cursor on appearance — the trailing weight applies to movement only
    currentX = targetX;
    currentY = targetY;
    applyTransform();
    if (!reduced) {
      stopLoop();
      rafId = requestAnimationFrame(tick);
    }
  };

  const handleMove = (event) => {
    // Missed-enter fallback: a cursor parked in the zone at init crosses no boundary
    if (!entered) {
      handleEnter(event);
      return;
    }
    const rect = zone.getBoundingClientRect();
    setDirection(directionAt(event.clientX, rect));
    updateTarget(event.clientX, event.clientY, rect);
    syncSuppressed(event);
    if (reduced) {
      currentX = targetX;
      currentY = targetY;
      applyTransform();
    }
  };

  const handleLeave = () => {
    entered = false;
    stopLoop();
    zone.classList.remove("is-suppressed");
  };

  const handleClick = (event) => {
    if (zone.classList.contains("is-disabled")) return;
    onNavigate(directionAt(event.clientX, zone.getBoundingClientRect()), event);
  };

  zone.addEventListener("mouseenter", handleEnter);
  zone.addEventListener("mousemove", handleMove);
  zone.addEventListener("mouseleave", handleLeave);
  zone.addEventListener("click", handleClick);

  arrow.classList.add(direction === "prev" ? "is-prev" : "is-next");
  syncState();
  // Revealed only now the follow is wired, so the pill can't flash parked in a corner
  zone.classList.add("is-ready");
  zone.dataset.cursorArrowInit = "true";

  return {
    sync: syncState,
    destroy: () => {
      stopLoop();
      zone.removeEventListener("mouseenter", handleEnter);
      zone.removeEventListener("mousemove", handleMove);
      zone.removeEventListener("mouseleave", handleLeave);
      zone.removeEventListener("click", handleClick);
      zone.classList.remove("is-ready", "is-disabled", "is-suppressed");
      delete zone.dataset.cursorArrowInit;
    },
  };
}

window.initCursorArrowZone = initCursorArrowZone;

// Countdown timer

class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.enableMockTimer =
      this.getAttribute("data-enable-mock-timer") === "true";

    if (this.enableMockTimer) {
      // get data for infinite mock timer
      const INFINITE_DAYS = Number(this.getAttribute("data-mock-end-day") || 2);
      const DIFF_HOURS = Number(this.getAttribute("data-mock-end-hour") || 3);
      const now = new Date();
      const futureDate = new Date(
        now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
      );
      const year = futureDate.getFullYear();
      const month = String(futureDate.getMonth() + 1).padStart(2, "0");
      const day = String(futureDate.getDate()).padStart(2, "0");
      const hours = String(futureDate.getHours()).padStart(2, "0");
      const minutes = String(futureDate.getMinutes()).padStart(2, "0");
      this.endDate = `${year}-${month}-${day}`;
      this.endTime = `${hours}:${minutes}`;
    } else {
      // get data from section settings
      this.endDate = this.getAttribute("data-end-date");
      this.endTime = this.getAttribute("data-end-time");
    }
    // ----------------------------------------------------------------
    this.interval;
    this.isStarted = false;
    this.onInit(this.endDate, this.endTime);
    this.startCountdownInterval(this.endDate, this.endTime);
  }

  onInit(endDate, endTime) {
    this.completeBehavior = this.getAttribute("data-complete-behavior");
    this.parentEl = this.closest(
      ".block-countdown-timer, .product-countdown-timer"
    );
    this.countdownBar = this.closest(".product-countdown");
    this.countdownTimerEl = this.querySelector(".countdown-timer__timer");
    this.countdownEndEl = this.querySelector(".countdown-timer__end");
    this.daysEl = this.querySelector(".js-countdown-timer-days");
    this.hoursEl = this.querySelector(".js-countdown-timer-hours");
    this.minutesEl = this.querySelector(".js-countdown-timer-minutes");
    this.secondsEl = this.querySelector(".js-countdown-timer-seconds");
    // ----------------------------------------------------------------
    const countdownDate = new Date(`${endDate}T${endTime}`);
    const now = new Date();
    const distance = countdownDate.getTime() - now.getTime();
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // ----------------------------------------------------------------
    this.updateProductProgressRing(distance);

    if (distance < 0 && this.completeBehavior === "hide_block") {
      if (this.parentEl) {
        this.parentEl.style.display = "none";
      }
      if (this.countdownBar) {
        this.countdownBar.hidden = true;
      }
      this.style.display = "none";
      clearInterval(this.interval);
    } else if (distance < 0 && this.completeBehavior === "show_message") {
      if (this.countdownTimerEl) {
        this.countdownTimerEl.style.display = "none";
      }
      if (this.countdownEndEl) {
        this.countdownEndEl.style.display = "flex";
      }
      clearInterval(this.interval);
    } else {
      if (this.daysEl) {
        this.daysEl.textContent = this.getTwoDigitTime(days);
      }

      if (this.hoursEl) {
        this.hoursEl.textContent = this.getTwoDigitTime(hours);
      }

      if (this.minutesEl) {
        this.minutesEl.textContent = this.getTwoDigitTime(minutes);
      }

      if (this.secondsEl) {
        this.secondsEl.textContent = this.getTwoDigitTime(seconds);
      }
    }
  }

  getTwoDigitTime(time) {
    if (String(time).length === 1) {
      return "0" + time;
    }
    if (String(time) === "-1") {
      return "00";
    }
    return time;
  }

  updateProductProgressRing(distanceMs) {
    if (!this.countdownBar) return;

    if (distanceMs <= 0) {
      this.setRingProgress(0);
      return;
    }

    // Fixed reference window from Liquid. The ring shows the fraction of this
    // window that is still remaining, so it must NOT be the live remaining time
    // (otherwise progress would always be 100%).
    const totalSeconds = Number(this.countdownBar.dataset.countdownTotal || 0);
    const totalMs = totalSeconds > 0 ? totalSeconds * 1000 : distanceMs;

    const progress = Math.min(Math.max((distanceMs / totalMs) * 100, 0), 100);
    this.setRingProgress(progress);
  }

  setRingProgress(progress) {
    if (!this.countdownBar) return;

    const svg = this.countdownBar.querySelector(".product-countdown__ring");
    if (!svg) return;

    const progressValue = Math.min(Math.max(progress, 0), 100);
    const circumference = 31.416;
    const dashOffset = ((100 - progressValue) / 100) * circumference;
    const progressCircle = svg.querySelector("circle:last-child");

    if (!progressCircle) return;

    progressCircle.setAttribute("stroke-dashoffset", String(dashOffset));
    progressCircle.style.strokeDashoffset = String(dashOffset);
    svg.setAttribute("data-progress", String(progressValue));
  }

  startCountdownInterval(endDate, endTime) {
    clearInterval(this.interval);
    this.interval = setInterval(this.onInit.bind(this, endDate, endTime), 1000);
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}

/**
 * Hover-capable devices use pure CSS; touch devices get click/tap handlers to toggle submenus.
 */

document.addEventListener("DOMContentLoaded", function () {
  const submenuItems = document.querySelectorAll(".header__submenu-details");
  const isTouchDevice = window.matchMedia(
    "(hover: none), (pointer: coarse)"
  ).matches;

  if (!isTouchDevice) {
    return;
  }

  function handleTouchClick(event) {
    event.stopPropagation();

    const currentItem = this;
    const isOpen = currentItem.classList.contains("is-open");

    submenuItems.forEach((item) => {
      if (item !== currentItem && item.classList.contains("is-open")) {
        item.classList.remove("is-open");
      }
    });

    if (isOpen) {
      currentItem.classList.remove("is-open");
    } else {
      currentItem.classList.add("is-open");
    }
  }

  submenuItems.forEach((item) => {
    item.addEventListener("click", handleTouchClick);
  });

  document.addEventListener("click", function (event) {
    const isClickInside = event.target.closest(".header__submenu-details");
    if (!isClickInside) {
      submenuItems.forEach((item) => {
        item.classList.remove("is-open");
      });
    }
  });
});

// MEGA MENU TABS — items with a submenu stay active after hover-out; the first
// tab is open by default and restored on header.js's "megamenu:closed" event.

(() => {
  const boundTriggers = new WeakSet();
  const boundSubmenus = new WeakSet();
  const initializedWrappers = new WeakSet();

  function getTab(trigger) {
    const wrapper = trigger.closest(".mega-menu__menu-wrapper");
    const tabId = trigger.dataset.tabTrigger;
    if (!wrapper || !tabId) return null;

    return wrapper.querySelector(
      `.mega-menu__subitems[data-tab-content="${tabId}"]`
    );
  }

  function hasSubmenu(trigger) {
    const tab = getTab(trigger);
    return Boolean(tab && tab.children.length);
  }

  function updateButtonClass(trigger, className) {
    const button = trigger.querySelector(".mega-menu__menu-item-button");
    if (!button) return;

    button.classList.remove("hover-active", "hover-inactive");

    if (className) {
      button.classList.add(className);
    }
  }

  function clearTabs(wrapper) {
    wrapper
      .querySelectorAll(".mega-menu__subitems")
      .forEach((tab) => tab.classList.remove("active"));
    wrapper.querySelectorAll(".mega-menu__menu-item").forEach((item) => {
      item.classList.remove("active");
      updateButtonClass(item, null);
    });
  }

  function showTab(trigger) {
    const wrapper = trigger.closest(".mega-menu__menu-wrapper");
    if (!wrapper) return;

    clearTabs(wrapper);

    const targetTab = getTab(trigger);
    if (targetTab) targetTab.classList.add("active");
    trigger.classList.add("active");
    updateButtonClass(trigger, "hover-active");
  }

  function hideTab(trigger) {
    if (!trigger.classList.contains("active")) {
      updateButtonClass(trigger, null);
    }
  }

  function applyDefaultState(wrapper) {
    clearTabs(wrapper);

    const firstItem = wrapper.querySelector(
      ".mega-menu__menu .mega-menu__menu-item"
    );
    if (firstItem && hasSubmenu(firstItem)) showTab(firstItem);
  }

  function handleTriggerActivation(trigger, event) {
    const mode = trigger.dataset.interactionMode || "hover";

    if (mode === "click" || event?.type === "keydown") {
      if (trigger.classList.contains("active")) {
        const wrapper = trigger.closest(".mega-menu__menu-wrapper");
        if (wrapper) clearTabs(wrapper);
        updateButtonClass(trigger, "hover-inactive");
      } else {
        showTab(trigger);
      }
    } else {
      showTab(trigger);
    }
  }

  function bindTrigger(trigger) {
    const mode = trigger.dataset.interactionMode || "hover";

    if (mode === "click") {
      trigger.addEventListener("click", (e) => {
        handleTriggerActivation(trigger, e);
      });

      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleTriggerActivation(trigger, e);
        }
      });
    } else {
      trigger.addEventListener("mouseenter", () => {
        handleTriggerActivation(trigger);
      });
      trigger.addEventListener("mouseleave", () => {
        hideTab(trigger);
      });

      trigger.addEventListener("focus", () => {
        handleTriggerActivation(trigger);
      });
      trigger.addEventListener("blur", (e) => {
        const isRelatedInsideMenu = e.relatedTarget?.closest?.(
          ".mega-menu__subitems"
        );

        if (!isRelatedInsideMenu) {
          hideTab(trigger);
        }
      });

      // Tab from trigger link → first subitem link
      const triggerLink = trigger.querySelector(".mega-menu__menu-item-link");
      if (triggerLink) {
        triggerLink.addEventListener("keydown", (e) => {
          if (e.key === "Tab" && !e.shiftKey) {
            const firstSubitemLink = getTab(trigger)?.querySelector("a");
            if (firstSubitemLink) {
              e.preventDefault();
              // The panel may have been deactivated meanwhile — a hidden link
              // can't take focus, so re-activate the tab before entering it.
              showTab(trigger);
              firstSubitemLink.focus();
            }
          }
        });
      }
    }

    if (!trigger.getAttribute("tabindex")) {
      trigger.setAttribute("tabindex", "0");
    }
  }

  // No submenu of its own: entering the item still deactivates the previous one.
  function bindPassiveItem(item) {
    const clear = () => {
      const wrapper = item.closest(".mega-menu__menu-wrapper");
      if (wrapper) clearTabs(wrapper);
    };
    const mode = item.dataset.interactionMode || "hover";

    if (mode === "click") {
      item.addEventListener("click", clear);
    } else {
      item.addEventListener("mouseenter", clear);
      item.addEventListener("focusin", clear);
    }
  }

  // Subitem keyboard navigation: Shift+Tab first → trigger link; Tab last → next trigger
  function bindSubmenuKeyboardNav(submenu) {
    const subitemLinks = Array.from(submenu.querySelectorAll("a"));
    if (!subitemLinks.length) return;

    const menuWrapper = submenu.closest(".mega-menu__menu-wrapper");
    const panelTabId = submenu.dataset.tabContent;
    const correspondingTrigger = menuWrapper?.querySelector(
      `.mega-menu__menu-item[data-tab-trigger="${panelTabId}"]`
    );
    const panelTriggerLink = correspondingTrigger?.querySelector(
      ".mega-menu__menu-item-link"
    );
    const menuItems = Array.from(
      menuWrapper?.querySelectorAll(".mega-menu__menu .mega-menu__menu-item") ||
        []
    );

    // Remove subitems from natural Tab flow — navigation handled fully by JS
    subitemLinks.forEach((link) => link.setAttribute("tabindex", "-1"));

    subitemLinks.forEach((link, idx) => {
      link.addEventListener("keydown", (e) => {
        if (e.key !== "Tab") return;

        if (e.shiftKey) {
          e.preventDefault();
          if (idx > 0) {
            subitemLinks[idx - 1].focus();
          } else if (panelTriggerLink) {
            showTab(correspondingTrigger);
            panelTriggerLink.focus();
          }
        } else {
          if (idx < subitemLinks.length - 1) {
            e.preventDefault();
            subitemLinks[idx + 1].focus();
          } else {
            // Last subitem: → next menu item or additional-menu or natural exit
            const itemIndex = menuItems.indexOf(correspondingTrigger);
            let nextItem = null;
            let nextFocusTarget = null;
            for (const item of menuItems.slice(itemIndex + 1)) {
              const link = item.querySelector(".mega-menu__menu-item-link");
              const target = link || (item.tabIndex >= 0 ? item : null);
              if (target) {
                nextItem = item;
                nextFocusTarget = target;
                break;
              }
            }
            if (nextItem) {
              e.preventDefault();
              if (hasSubmenu(nextItem)) showTab(nextItem);
              nextFocusTarget.focus();
            } else {
              const firstAdditionalLink = menuWrapper?.querySelector(
                ".mega-menu__additional-menu .mega-menu__additional-menu-item-link"
              );
              if (firstAdditionalLink) {
                e.preventDefault();
                firstAdditionalLink.focus();
              }
            }
          }
        }
      });
    });
  }

  const initMegaMenuTabs = () => {
    document
      .querySelectorAll(".mega-menu__menu .mega-menu__menu-item")
      .forEach((item) => {
        if (boundTriggers.has(item)) return;
        boundTriggers.add(item);

        if (hasSubmenu(item)) {
          bindTrigger(item);
        } else {
          bindPassiveItem(item);
        }
      });

    document.querySelectorAll(".mega-menu__subitems").forEach((submenu) => {
      if (boundSubmenus.has(submenu)) return;
      boundSubmenus.add(submenu);
      bindSubmenuKeyboardNav(submenu);
    });

    document.querySelectorAll(".mega-menu__menu-wrapper").forEach((wrapper) => {
      if (initializedWrappers.has(wrapper)) return;
      initializedWrappers.add(wrapper);
      applyDefaultState(wrapper);
    });
  };

  document.addEventListener("DOMContentLoaded", initMegaMenuTabs);
  // Header is re-rendered in the theme editor; wire up any fresh triggers.
  document.addEventListener("shopify:section:load", initMegaMenuTabs);

  document.addEventListener("megamenu:closed", (event) => {
    if (!(event.target instanceof Element)) return;
    event.target
      .querySelectorAll(".mega-menu__menu-wrapper")
      .forEach(applyDefaultState);
  });
})();

if (!customElements.get("modal-close-cursor")) {
  customElements.define(
    "modal-close-cursor",
    class ModalCloseCursor extends HTMLElement {
      constructor() {
        super();

        this.handleMove = this.onMove.bind(this);
        this.handleLeave = this.onLeave.bind(this);
        this.tick = this.onTick.bind(this);

        this.targetX = 0;
        this.targetY = 0;
        this.x = 0;
        this.y = 0;
        this.raf = null;
        this.visible = false;
        this.positioned = false;
        this.active = false;
        this.host = null;
        this.contentEl = null;

        this.mediaQuery =
          typeof window.matchMedia === "function"
            ? window.matchMedia(
                "(min-width: 990px) and (hover: hover) and (pointer: fine)"
              )
            : null;
      }

      connectedCallback() {
        this.host = this.parentElement;
        const contentSelector = this.getAttribute("data-content");
        if (!contentSelector) return;

        if (contentSelector.charAt(0) === "#") {
          this.contentEl = document.querySelector(contentSelector);
          return;
        }

        if (this.host) {
          this.contentEl = this.host.querySelector(contentSelector);
        }
      }

      disconnectedCallback() {
        this.deactivate();
      }

      isEnabled() {
        return (
          Boolean(this.host) && (!this.mediaQuery || this.mediaQuery.matches)
        );
      }

      activate() {
        if (this.active || !this.isEnabled()) return;
        this.active = true;
        this.host.addEventListener("mousemove", this.handleMove);
        this.host.addEventListener("mouseleave", this.handleLeave);
        this.raf = requestAnimationFrame(this.tick);
      }

      deactivate() {
        if (this.host) {
          this.host.removeEventListener("mousemove", this.handleMove);
          this.host.removeEventListener("mouseleave", this.handleLeave);
        }
        if (this.raf !== null) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
        this.hide();
        this.style.transform = "translate3d(-100vw, -100vh, 0)";
        this.positioned = false;
        this.active = false;
      }

      show() {
        if (this.visible) return;
        this.classList.add("is-visible");
        this.host?.classList.add("modal-cursor-shown");
        this.visible = true;
      }

      hide() {
        if (!this.visible) return;
        this.classList.remove("is-visible");
        this.host?.classList.remove("modal-cursor-shown");
        this.visible = false;
      }

      onMove(event) {
        const anchor = this.offsetParent || this.host;
        if (!anchor) return;

        const rect = anchor.getBoundingClientRect();
        this.targetX = event.clientX - rect.left;
        this.targetY = event.clientY - rect.top;

        const overContent =
          this.contentEl && this.contentEl.contains(event.target);

        if (overContent) {
          this.hide();
          return;
        }

        if (!this.positioned) {
          this.x = this.targetX;
          this.y = this.targetY;
          this.positioned = true;
        }

        this.show();
      }

      onLeave() {
        this.hide();
      }

      onTick() {
        const ease = 0.18;
        this.x += (this.targetX - this.x) * ease;
        this.y += (this.targetY - this.y) * ease;
        this.style.transform = `translate3d(${this.x}px, ${this.y}px, 0) translate(-50%, -50%)`;
        this.raf = requestAnimationFrame(this.tick);
      }
    }
  );
}

/*
 * Newsletter forms: remember which form was submitted so the failed one can be
 * refocused after the reload. Success is handled by the form toasts below.
 */
(() => {
  const getNewsletterFormId = (form) => {
    const input = form.querySelector('input[id^="NewsletterForm--"]');
    return input ? input.id.replace("NewsletterForm--", "") : null;
  };

  const bindNewsletterForms = () => {
    document.querySelectorAll("form.newsletter-form").forEach((form) => {
      if (form.dataset.newsletterBound === "true") return;
      form.dataset.newsletterBound = "true";

      form.addEventListener("submit", () => {
        const formId = getNewsletterFormId(form);
        if (formId) {
          sessionStorage.setItem("newsletter-form-source", formId);
        }
      });
    });
  };

  const handleNewsletterError = () => {
    const hasError = document.querySelector(
      'form.newsletter-form input[aria-invalid="true"]'
    );

    const sourceId = sessionStorage.getItem("newsletter-form-source");
    sessionStorage.removeItem("newsletter-form-source");

    if (!hasError || !sourceId) return;

    window.scrollTo(0, 0);

    const targetInput = document.getElementById("NewsletterForm--" + sourceId);
    if (!targetInput || targetInput.getAttribute("aria-invalid") !== "true") {
      return;
    }

    // popup.js reopens the popup the failed form lives in (if any).
    const popup = targetInput.closest(".popup");
    if (popup) {
      document.dispatchEvent(
        new CustomEvent("popup:open", { detail: { popup: popup } })
      );
    }

    targetInput.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  };

  document.addEventListener("DOMContentLoaded", () => {
    bindNewsletterForms();
    // setTimeout: global.js runs before popup.js, so its DOMContentLoaded
    // handler fires first — defer so popup.js can attach its popup:open
    // listener before we might dispatch it.
    setTimeout(handleNewsletterError, 0);
  });

  document.addEventListener("shopify:section:load", bindNewsletterForms);
})();

// Success toasts for forms that reload the page — the URL param Shopify
// returns with says which one was posted.
(() => {
  // First match wins: back-in-stock shares contact_posted with the contact
  // form and is told apart by the form hash.
  const FORM_TOASTS = [
    {
      param: "customer_posted",
      value: "true",
      text: "data-newsletter-success-text",
      scrollTop: true,
    },
    {
      param: "contact_posted",
      value: "true",
      hash: "#BackInStockAlertForm-",
      text: "data-back-in-stock-success-text",
    },
    {
      param: "contact_posted",
      value: "true",
      text: "data-contact-success-text",
    },
    {
      param: "comment",
      text: "data-comment-success-text",
    },
  ];

  const handleFormSuccess = () => {
    const params = new URLSearchParams(window.location.search);
    const hash = window.location.hash;

    const match = FORM_TOASTS.find((entry) => {
      const value = params.get(entry.param);
      if (value === null) return false;
      if (entry.value && value !== entry.value) return false;
      return !entry.hash || hash.startsWith(entry.hash);
    });

    if (!match) return;

    const toast = document.querySelector("toast-notification");
    if (!toast || typeof window.showToast !== "function") return;

    // Clean the URL so a refresh doesn't re-show the toast.
    params.delete(match.param);
    const query = params.toString();
    history.replaceState(
      null,
      "",
      window.location.pathname + (query ? "?" + query : "")
    );

    if (match.scrollTop) window.scrollTo(0, 0);

    window.showToast(toast.getAttribute(match.text));
  };

  document.addEventListener("DOMContentLoaded", handleFormSuccess);
})();
